// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1qvXM{display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;-ms-flex-pack:center;justify-content:center}._3-w6L{border-radius:8px;caret-color:transparent;height:40px;height:4rem;margin-left:1rem;padding:0;text-align:center;width:40px;width:4rem}._3-w6L:first-child{margin-left:0}", ""]);
// Exports
exports.locals = {
	"number": "_1qvXM",
	"number__digit": "_3-w6L"
};
module.exports = exports;
